import { Action } from 'redux';

import { EComparisonNotificationCategory } from '../../types/offersComparion';

export type TAddToComparison = 'offersComparison/ADD_TO_COMPARISON';
export type TDeleteFromComparison = 'offersComparison/DELETE_FROM_COMPARISON';
export type TSetComparisonNotification = 'offersComparison/notification/SET_COMPARISON_NOTIFICATION';
export type TClearComparisonNotification = 'offersComparison/notification/CLEAR_COMPARISON_NOTIFICATION';

export interface IAddToComparison extends Action<TAddToComparison> {
  offerId: number;
  type: TAddToComparison;
}

export interface IDeleteFromComparison extends Action<TDeleteFromComparison> {
  offerId: number;
  type: TDeleteFromComparison;
}

export interface ISetComparisonNotification extends Action<TSetComparisonNotification> {
  text: string;
  category: EComparisonNotificationCategory;
  offerId: number;
  url?: string | null;
  type: TSetComparisonNotification;
}

export interface IClearComparisonNotification extends Action<TClearComparisonNotification> {
  type: TClearComparisonNotification;
}

export const ADD_TO_COMPARISON: TAddToComparison = 'offersComparison/ADD_TO_COMPARISON';
export const DELETE_FROM_COMPARISON: TDeleteFromComparison = 'offersComparison/DELETE_FROM_COMPARISON';
export const SET_COMPARISON_NOTIFICATION: TSetComparisonNotification =
  'offersComparison/notification/SET_COMPARISON_NOTIFICATION';
export const CLEAR_COMPARISON_NOTIFICATION: TClearComparisonNotification =
  'offersComparison/notification/CLEAR_COMPARISON_NOTIFICATION';
